/*jshint esversion: 6 */
/*global window*/

//redefine console.log
//console.log = function() {};

const _ = require("lodash");

import $ from "jquery";
import jQuery from "jquery";
window.$ = jQuery;

// //Import Vue
import * as  Vue from 'vue';
window.Vue = Vue;

